var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	84512: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_19__angular_compiler_21_2_19_rxjs_7_8_2_zone_js_0-5c5cf2"), __webpack_require__.e("default-node_modules_pnpm_angular_core_21_2_19__angular_compiler_21_2_19_rxjs_7_8_2_zone_js_0-37198c"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_pnpm_angular_core_21_2_19__angular_compiler_21_2_19_rxjs_7_8_2_zone_js_0_16_2_no-48c47a")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 6648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	32966: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_tslib_2_8_1_node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 81228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	94710: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_pnpm_tslib_2_8_1_node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_internal_operators_auditTime_-6b9e6f"), __webpack_require__.e("node_modules_pnpm_rxjs_7_8_2_node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 14738))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	84016: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 67669))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	48394: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 62679))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	41116: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_pnpm_angular_common_21_2_19__angular_core_21_2_19__angular_compiler_21_2-044b3e")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 37450))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	73582: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_21_2_19__angular_animations_21_2_19__angul-eebe95"), __webpack_require__.e("default-node_modules_pnpm_angular_platform-browser_21_2_19__angular_animations_21_2_19__angul-5f330a")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 29041))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	76167: {
		fallback: () => (__webpack_require__.e("default-node_modules_pnpm_angular_animations_21_2_19__angular_core_21_2_19__angular_compiler_-e9aded").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 88720))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	27870: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_common_21_2_19__angular_core_21_2_19__angular_compiler_21_2-96e2c7")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 17329))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	3623: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-typography */ 37464))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-typography",

	},
	88661: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-libs_client_ui_adk-button_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-button */ 36213))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-button",

	},
	31139: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-libs_client_ui_core_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @api-guardian/client-core */ 66999))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/client-core",

	},
	79267: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-typography_api-guardian_adk-typography"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-button_api-guardian_adk-button"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-card_api-guardian_adk-card"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_client-core_api-guardian_client-core"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-expansion-panel_api-guardian_adk-exp-8a23e2"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_field-types_path-methods-fi-e91292"), __webpack_require__.e("default-webpack_sharing_consume_default_moment_moment"), __webpack_require__.e("default-webpack_sharing_consume_default_flatpickr_flatpickr"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_field-types_select-field_co-756d39"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_field-types_status-code-fie-7e1169"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_field-types_chips-field_com-081080"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_adk-form-builder_component_ts"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_lib_adk-form-ui_components_field-types_date-range-fiel-075370"), __webpack_require__.e("default-libs_client_ui_adk-form-ui_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-form-ui */ 48550))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-form-ui",

	},
	56239: {
		fallback: () => (__webpack_require__.e("default-libs_client_ui_adk-expansion-panel_src_index_ts").then(() => (() => (__webpack_require__(/*! @api-guardian/adk-expansion-panel */ 68491))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-expansion-panel",

	},
	60305: {
		fallback: () => (__webpack_require__.e("default-libs_client_ui_adk-tabs_src_index_ts").then(() => (() => (__webpack_require__(/*! @api-guardian/adk-tabs */ 55305))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-tabs",

	},
	31977: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_pnpm_angular_router_21_2_19__angular_common_21_2_19__angular_core_21_2_1-102f28")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 74695))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	97638: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_pnpm_angular_cdk_21_2_14__angular_common_21_2_19__angular_core_21_2_19__-81833e"), __webpack_require__.e("default-node_modules_pnpm_angular_material_21_2_14_e62c7210bef08c270f76f8032e5d0530_node_modu-821661")]).then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 68571))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/tooltip",

	},
	27456: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_moment_2_30_1_node_modules_moment_moment_js").then(() => (() => (__webpack_require__(/*! moment */ 84276))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.30.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment",

	},
	11485: {
		fallback: () => (__webpack_require__.e("default-libs_client_ui_adk-switch_src_index_ts").then(() => (() => (__webpack_require__(/*! @api-guardian/adk-switch */ 44989))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-switch",

	},
	31724: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_tslib_2_8_1_node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_pnpm_angular_cdk_21_2_14__angular_common_21_2_19__angular_core_21_2_19__-81833e"), __webpack_require__.e("default-node_modules_pnpm_swimlane_ngx-charts_24_0_0_ca2a7653931c852bf6c623e6c00735c1_node_mo-8c73a7")]).then(() => (() => (__webpack_require__(/*! @swimlane/ngx-charts */ 80295))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "24.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@swimlane/ngx-charts",

	},
	67137: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_client-core_api-guardian_client-core"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-form-ui_api-guardian_adk-form-ui"), __webpack_require__.e("default-libs_client_ui_adk-side-panel_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-side-panel */ 74789))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-side-panel",

	},
	36893: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-card */ 4803))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-card",

	},
	4285: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_pnpm_angular_forms_21_2_19__angular_common_21_2_19__angular_core_21_2_19-bda3ad")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 2945))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	99127: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_flatpickr_4_6_13_node_modules_flatpickr_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! flatpickr */ 36015))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.6.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "flatpickr",

	},
	31433: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_lodash_4_18_1_node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 91651))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	25552: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_file-saver_2_0_5_node_modules_file-saver_dist_FileSaver_min_js").then(() => (() => (__webpack_require__(/*! file-saver */ 97091))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	72274: {
		fallback: () => (__webpack_require__.e("node_modules_pnpm_papaparse_5_7_0_node_modules_papaparse_papaparse_min_js").then(() => (() => (__webpack_require__(/*! papaparse */ 42957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "papaparse",

	},
	34929: {
		fallback: () => (__webpack_require__.e("default-node_modules_pnpm_angular_animations_21_2_19__angular_core_21_2_19__angular_compiler_-ed526a").then(() => (() => (__webpack_require__(/*! @angular/animations */ 2361))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	4793: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-form-ui_api-guardian_adk-form-ui"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-dialog */ 83381))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-dialog",

	},
	59031: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-typography_api-guardian_adk-typography"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-button_api-guardian_adk-button"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-card_api-guardian_adk-card"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-form-ui_api-guardian_adk-form-ui"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-expansion-panel_api-guardian_adk-exp-8a23e2"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_material_tooltip_angular_material_tooltip"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_api-guardian_adk-switch_api-guardian_adk-switch"), __webpack_require__.e("default-libs_client_ui_adk-table_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @api-guardian/adk-table */ 34801))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@api-guardian/adk-table",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		84512
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		32966
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		94710
	],
	"default-node_modules_pnpm_angular_core_21_2_19__angular_compiler_21_2_19_rxjs_7_8_2_zone_js_0-37198c": [
		84016,
		48394
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		41116
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		73582
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		76167
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		27870
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-typography_api-guardian_adk-typography": [
		3623
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-button_api-guardian_adk-button": [
		88661
	],
	"default-webpack_sharing_consume_default_api-guardian_client-core_api-guardian_client-core": [
		31139
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-form-ui_api-guardian_adk-form-ui": [
		79267
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-expansion-panel_api-guardian_adk-exp-8a23e2": [
		56239
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-tabs_api-guardian_adk-tabs": [
		60305
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		31977
	],
	"default-webpack_sharing_consume_default_angular_material_tooltip_angular_material_tooltip": [
		97638
	],
	"default-webpack_sharing_consume_default_moment_moment": [
		27456
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-switch_api-guardian_adk-switch": [
		11485
	],
	"default-libs_client_ui_adk-charts_src_index_ts": [
		31724
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-side-panel_api-guardian_adk-side-panel": [
		67137
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-card_api-guardian_adk-card": [
		36893
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		4285
	],
	"default-webpack_sharing_consume_default_flatpickr_flatpickr": [
		99127
	],
	"default-libs_client_ui_adk-form-ui_src_index_ts": [
		31433
	],
	"default-libs_client_ui_api_src_index_ts": [
		25552,
		72274
	],
	"default-node_modules_pnpm_swimlane_ngx-charts_24_0_0_ca2a7653931c852bf6c623e6c00735c1_node_mo-8c73a7": [
		34929
	],
	"default-webpack_sharing_consume_default_api-guardian_adk-dialog_api-guardian_adk-dialog-webpa-798c67": [
		4793,
		59031
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}